// extracted by mini-css-extract-plugin
export default {"socLink":"SocialLink_socLink__GhARW"};